export var appInfo = {
    header: {
        topMenu: {
            items: [
                {
                    text: "Services",
                    href: "/services"
                },
                {
                    text: "Support",
                    href: "/",
                    type: "support",
                },
                {
                    text: "News",
                    href: "/#news",
                },
                {
                    type: "rule",
                },
                {
                    text: "Contact Us",
                    href: "/",
                    type: "contact-us",
                }
            ]
        }
    },
    footer: {
        sections: [
            {
                header: "Products",
                items: [
                    {
                        text: "SaaS Cloud",
                        href: "/cloud-solutions"
                    },
                    {
                        text: "Client Services",
                        href: "/services"
                    },
                    {
                        text: "Fm-Pro Login",
                        href: "https://fm-pro.net/Account/Login?ReturnUrl=%2F",
                        target: "_blank"
                    }
                ]
            },
            {
                header: "Corporate Information",
                items: [
                    {
                        text: "Package Delivery",
                        href: "#",
                        type: "deliveries"
                    },
                    {
                        type: "phone",
                        src: "/phone.svg",
                        text: "CALL US",
                        phoneNumber: "978-455-0441",
                        href: "#"
                    }
                ]
            },
            {
                header: "User Notices",
                items: [
                    {
                        text: "Terms & Conditions",
                        href: "/terms-and-conditions"
                    },
                    {
                        text: "Privacy Policy",
                        href: "/privacy-policy"
                    },
                    {
                        text: "Purchasing Policy",
                        href: "/purchasing-policy"
                    }
                ]
            },
            {
                header: "Follow Us",
                items: [
                    {
                        type: "img-button",
                        src: "/LinkedIn.svg",
                        target: "_blank",
                        text: "LinkedIn",
                        href: "https://www.linkedin.com/company/digital-facilities-corporation/"
                    },
                    {
                        type: "img-button",
                        src: "/X.svg",
                        target: "_blank",
                        text: "X",
                        href: "https://twitter.com/DFCSoftware"
                    },
                    {
                        type: "img-button",
                        src: "/FB.svg",
                        target: "_blank",
                        text: "Facebook",
                        href: "https://www.facebook.com/DigitalFacilities"
                    }
                ]
            },
            {
                header: "Endorsed Assoc.",
                items: [
                    {
                        type: "img-button",
                        src: "/csi.png",
                        target: "_blank",
                        maxHeight: "50px",
                        href: "https://www.csiresources.org/home"
                    },
                    {
                        type: "img-button",
                        src: "/ASTM.png",
                        target: "_blank",
                        maxHeight: "50px",
                        href: "https://www.astm.org/"
                    }
                ]
            }
        ]
    }
}